const LOGGED_OUT_CARDS_PER_PAGE = 20;
const LOGGED_IN_CARDS_PER_PAGE = 9;
const MAX_LOGGED_OUT_ITEMS = 100;

export {
  LOGGED_IN_CARDS_PER_PAGE,
  LOGGED_OUT_CARDS_PER_PAGE,
  MAX_LOGGED_OUT_ITEMS,
};
